import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBdName, FormItemBdNo} from '../BD/FormChooseBd.jsx'
import {FormItemAlgTitle, FormItemStoryType} from '../BDSUMMARY/FormChooseBdsummary.jsx'

export default function FormChooseBdsummary(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemBdNo />
            <FormItemBdName />
            <FormItemAlgTitle />
            <FormItemStoryType />
        </FormChooseExternal>
    )
}
